// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__pPQD4","modal":"Modal_modal__Yb3rB"};